import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 12.667C4 13.4 4.6 14 5.333 14h5.333C11.4 14 12 13.4 12 12.667v-8H4zm8.666-10h-2.333L9.666 2H6.333l-.667.667H3.333V4h9.333z"
    }, null, -1)
  ])))
}
export default { render: render }